import React, { useState } from "react";
import "../../Style/RegisterNewUserModal.css";
import mv_gif1 from "../../Images/mv-gif1.gif";
import mv_gif2 from "../../Images/mv-gif2.gif";
import mv_gif3 from "../../Images/mv-gif3.gif";
import { ToastContainer, toast } from "react-toastify";
import { Modal, Tooltip } from "@mui/material";
import countryData from "../../Utils/countryData.json";
import { path_url } from "../../Config/config";
import axios from "axios";

// Must match backend TimeZone enum exactly
const TIMEZONE_OPTIONS = [
  "UTC_MINUS_12",
  "UTC_MINUS_11",
  "UTC_MINUS_10",
  "UTC_MINUS_9",
  "UTC_MINUS_8",
  "UTC_MINUS_7",
  "UTC_MINUS_6",
  "UTC_MINUS_5",
  "UTC_MINUS_4",
  "UTC_MINUS_3_30",
  "UTC_MINUS_3",
  "UTC_MINUS_2",
  "UTC_MINUS_1",
  "UTC",
  "UTC_PLUS_1",
  "UTC_PLUS_2",
  "UTC_PLUS_3",
  "UTC_PLUS_3_30",
  "UTC_PLUS_4",
  "UTC_PLUS_4_30",
  "UTC_PLUS_5",
  "UTC_PLUS_5_30",
  "UTC_PLUS_5_45",
  "UTC_PLUS_6",
  "UTC_PLUS_6_30",
  "UTC_PLUS_7",
  "UTC_PLUS_8",
  "UTC_PLUS_9",
  "UTC_PLUS_9_30",
  "UTC_PLUS_10",
  "UTC_PLUS_11",
  "UTC_PLUS_12",
  "UTC_PLUS_13",
  "UTC_PLUS_14",
  "PST",
  "MST",
  "CST",
  "EST",
  "GMT",
  "CET",
  "EET",
  "JST",
  "AEDT",
  "AEST",
  "ACST",
  "NZDT",
  "NZST",
];

// Must match backend Currencies enum exactly
const CURRENCIES_OPTIONS = [
  "USD",
  "EUR",
  "JPY",
  "GBP",
  "AUD",
  "CAD",
  "CHF",
  "CNY",
  "SEK",
  "NZD",
  "MXN",
  "SGD",
  "HKD",
  "NOK",
  "KRW",
  "TRY",
  "RUB",
  "INR",
  "BRL",
  "ZAR",
  "SAR",
  "AED",
  "QAR",
  "OMR",
  "KWD",
  "MYR",
  "THB",
  "IDR",
  "VND",
  "EGP",
  "NGN",
  "KES",
  "PLN",
  "HUF",
  "CZK",
  "DKK",
  "ARS",
  "CLP",
  "COP",
  "PEN",
  "ILS",
  "PHP",
  "TWD",
  "PKR",
  "BDT",
  "LKR",
];

// Must match backend CompanyType enum exactly
const COMPANY_TYPE_OPTIONS = [
  "PRIVATELTDCO",
  "OTHERS",
  "GOVERNMENT",
  "INDIVIDUAL",
  "PROPRIETARY",
  "REGISTEREDTRUST",
  "PARTNERSHIP",
  "SOCIETY",
  "COOPSOCIETY",
];

const RegisterNewUserModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const nPages = 3; // Updated to 3 pagesw
  const [currentPageTransition, setCurrentPageTransition] = useState("");
  const [companyLogo, setCompanyLogo] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);

  const [pageContents, setPageContents] = useState([
    {
      image: mv_gif1,
      inputFields: [
        { name: "companyName", value: "" },
        { name: "companyType", value: "" },
        { name: "address", value: "" },
        { name: "country", value: "" },
        { name: "state", value: "" },
        { name: "pincode", value: "" },
        { name: "phoneNumber", value: "" },
        { name: "email", value: "" },
        { name: "currencies", value: "" },
        { name: "timezone", value: "" },
        { name: "businessHours", value: "" },
        { name: "logo", value: "" },
      ],
      inputFieldPlaceholders: [
        "Company Name",
        "Company Type",
        "Company Address",
        "Company Country",
        "Company State",
        "Company Pincode",
        "Company Phone number",
        "Company Email",
        "Company Currencies",
        "Company Timezone",
        "Company Business Hours",
        "Upload Company Logo",
      ],
    },
    {
      image: mv_gif2,
      inputFields: [
        { name: "name", value: "" },
        { name: "email", value: "" },
        { name: "contact", value: "" },
        { name: "designation", value: "" },
        { name: "skill", value: "" },
        { name: "country", value: "" }, // Dropdown for country (index 5)
        { name: "state", value: "" }, // Normal input for state
        { name: "notes", value: "" },
        { name: "profile_photo", value: "" },
      ],
      inputFieldPlaceholders: [
        "Full Name",
        "Email Address",
        "Contact Number",
        "Designation",
        "Skills",
        "Select Country",
        "State",
        "Notes",
        "Upload Profile Picture",
      ],
    },
    {
      image: mv_gif3,
      inputFields: [
        { name: "invoiceFormat", value: "" },
        { name: "invoiceDueDayPeriod", value: "" },
        { name: "taskDueDayPeriod", value: "" },
        { name: "serviceRequestDueDayPeriod", value: "" },
        { name: "interactionRecordDueDayPeriod", value: "" },
        { name: "purchaseOrderDueDayPeriod", value: "" },
        { name: "quotationDueDayPeriod", value: "" },
        { name: "currency", value: "" },
        { name: "invoiceLogoFile", value: "" },
      ],
      inputFieldPlaceholders: [
        "Enter invoice format",
        "Enter invoice due day period",
        "Enter task due day period",
        "Enter service request due day period",
        "Enter interaction record due day period",
        "Enter purchase order due day period",
        "Enter quotation due day period",
        "Enter currency",
        "Upload invoice logo ",
      ],
    },
  ]);

  // update these below values if page contents state is modified (refering to pageContents.inputFields)
  // Page 1 (Company): companyName(0), companytype(1), address(2), country(3), state(4), city(5), phoneNumber(6), email(7), currencies(8), timezone(9), businessHours(10), logo(11)
  const inputCountryIndex = 3; // page 1: country dropdown
  const inputCurrencyIndex = 8; // page 1: currencies dropdown
  const inputTimezoneIndex = 9; // page 1: timezone dropdown
  const inputCompanyTypeIndex = 1; // page 1: company type dropdown
  // Page 2 (Profile): name(0), email(1), contact(2), designation(3), skill(4), country(5), state(6), notes(7), profile_photo(8)
  const inputCountryIndex2 = 5; // page 2: country dropdown

  // this function is responsible for storing the user input
  const handleChange = (e, pageIndex, fieldIndex, countryIndex = null) => {
    try {
      const { value } = e.target;
      const updatedPageContents = [...pageContents];
      updatedPageContents[pageIndex].inputFields[fieldIndex].value = value;

      if (fieldIndex === inputCountryIndex && countryIndex !== null) {
        const currencyCode = countryData.countries[countryIndex].currency_code;
        updatedPageContents[pageIndex].inputFields[inputCurrencyIndex].value =
          currencyCode;
      }

      setPageContents(updatedPageContents);
      if (e.target.type === "file") {
        handleImageChange(e, pageIndex); // Call handleImage function for handling image files
      }
      console.log(pageContents[0].inputFields);
    } catch (error) {
      console.log(error);
      toast.error("Fill Data Correctly");
    }
  };

  const handleImageChange = (e, pageIndex) => {
    const file = e.target.files[0];
    if (!file) return;

    if (pageIndex === 0) {
      setCompanyLogo(file);
    } else {
      setProfilePhoto(file);
    }
  };

  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // resets all form fields across all pages without closing the modal
  const handleCancel = () => {
    setPageContents((prev) =>
      prev.map((page) => ({
        ...page,
        inputFields: page.inputFields.map((field) => ({ ...field, value: "" })),
      })),
    );
    setCompanyLogo(null);
    setProfilePhoto(null);
    setCurrentPage(1);
  };

  // formatting the data to match api request body
  // WelcomeProfileRequest only accepts: userName, organization, profile
  const formatData = (adminId) => {
    // Enum fields: send as valid enum name or null (empty string causes 500)
    const currenciesVal = pageContents[0].inputFields.find(
      ({ name }) => name === "currencies",
    ).value;
    const timezoneVal = pageContents[0].inputFields.find(
      ({ name }) => name === "timezone",
    ).value;
    // companyType is an enum field — field name must be camelCase 'companyType' to match Java entity
    const companyTypeVal = pageContents[0].inputFields.find(
      ({ name }) => name === "companyType",
    ).value;

    const formData = {
      // userName from personal profile page
      userName:
        pageContents[1].inputFields.find(({ name }) => name === "name").value ||
        null,
      organization: {
        invoiceNumber: 0,
        invoiceString: "invoiceString_70f6fa156692",
        owneruserid: adminId,
        usercid: adminId,
        useradminid: adminId,
        companyName: pageContents[0].inputFields.find(
          ({ name }) => name === "companyName",
        ).value,
        companyType: companyTypeVal || null, // camelCase matches Java entity field
        address: pageContents[0].inputFields.find(
          ({ name }) => name === "address",
        ).value,
        country: pageContents[0].inputFields.find(
          ({ name }) => name === "country",
        ).value,
        state: pageContents[0].inputFields.find(({ name }) => name === "state")
          .value,
        pincode: pageContents[0].inputFields.find(
          ({ name }) => name === "pincode",
        ).value,
        phoneNumber: pageContents[0].inputFields.find(
          ({ name }) => name === "phoneNumber",
        ).value,
        email: pageContents[0].inputFields.find(({ name }) => name === "email")
          .value,
        // Enum fields: must be null (not empty string) when not provided, otherwise backend throws 500
        currencies: currenciesVal || null,
        timezone: timezoneVal || null,
        active: false,
        businesshours: pageContents[0].inputFields.find(
          ({ name }) => name === "businessHours",
        ).value,
      },
      profile: {
        useradminid: adminId,
        usercid: adminId,
        // Profile entity fields: designation, skill, country, state, notes
        designation: pageContents[1].inputFields.find(
          ({ name }) => name === "designation",
        ).value,
        skill: pageContents[1].inputFields.find(({ name }) => name === "skill")
          .value,
        country: pageContents[1].inputFields.find(
          ({ name }) => name === "country",
        ).value,
        state: pageContents[1].inputFields.find(({ name }) => name === "state")
          .value,
        notes: pageContents[1].inputFields.find(({ name }) => name === "notes")
          .value,
      },
    };

    console.log("Submitting payload:", JSON.stringify(formData, null, 2));
    return formData;
  };

  // this function will submit the form data using post method
  // Always save all form data to localStorage (regardless of API success)
  const saveToLocalStorage = () => {
    const p1 = pageContents[0].inputFields;
    const p2 = pageContents[1].inputFields;
    const p3 = pageContents[2].inputFields;

    // ── Personal Profile (Page 2) ──────────────────────────────────────────
    localStorage.setItem(
      "name",
      p2.find((f) => f.name === "name")?.value || "",
    );
    localStorage.setItem(
      "userName",
      p2.find((f) => f.name === "name")?.value || "",
    );
    localStorage.setItem(
      "userEmail",
      p2.find((f) => f.name === "email")?.value || "",
    );
    localStorage.setItem(
      "userContact",
      p2.find((f) => f.name === "contact")?.value || "",
    );
    localStorage.setItem(
      "userSkill",
      p2.find((f) => f.name === "skill")?.value || "",
    );
    localStorage.setItem(
      "userState",
      p2.find((f) => f.name === "state")?.value || "",
    );
    localStorage.setItem(
      "userNotes",
      p2.find((f) => f.name === "notes")?.value || "",
    );

    // ── My Settings ────────────────────────────────────────────────────────
    localStorage.setItem(
      "mySettingRole",
      p2.find((f) => f.name === "designation")?.value || "",
    );
    localStorage.setItem(
      "mySettingCompany",
      p1.find((f) => f.name === "companyName")?.value || "",
    );
    localStorage.setItem(
      "mySettingRegion",
      p1.find((f) => f.name === "country")?.value || "",
    );
    localStorage.setItem(
      "mySettingTimeZone",
      p1.find((f) => f.name === "timezone")?.value || "",
    );

    // ── Company Settings – General ─────────────────────────────────────────
    localStorage.setItem(
      "companySettingName",
      p1.find((f) => f.name === "companyName")?.value || "",
    );
    localStorage.setItem(
      "companySettingAddress",
      p1.find((f) => f.name === "address")?.value || "",
    );
    localStorage.setItem(
      "companySettingCity",
      p1.find((f) => f.name === "state")?.value || "",
    );
    localStorage.setItem(
      "companySettingPostCode",
      p1.find((f) => f.name === "pincode")?.value || "",
    );
    localStorage.setItem(
      "companySettingRegion",
      p1.find((f) => f.name === "country")?.value || "",
    );
    localStorage.setItem(
      "companySettingPhone",
      p1.find((f) => f.name === "phoneNumber")?.value || "",
    );
    localStorage.setItem(
      "companySettingVat",
      p1.find((f) => f.name === "email")?.value || "",
    );

    // ── Company Settings – Default Values (Page 3) ─────────────────────────
    localStorage.setItem(
      "defaultInvoiceFormat",
      p3.find((f) => f.name === "invoiceFormat")?.value || "",
    );
    localStorage.setItem(
      "defaultInvoiceDueDayPeriod",
      p3.find((f) => f.name === "invoiceDueDayPeriod")?.value || "",
    );
    localStorage.setItem(
      "defaultTaskDueDayPeriod",
      p3.find((f) => f.name === "taskDueDayPeriod")?.value || "",
    );
    localStorage.setItem(
      "defaultServiceRequestDueDayPeriod",
      p3.find((f) => f.name === "serviceRequestDueDayPeriod")?.value || "",
    );
    localStorage.setItem(
      "defaultInteractionRecordDueDayPeriod",
      p3.find((f) => f.name === "interactionRecordDueDayPeriod")?.value || "",
    );
    localStorage.setItem(
      "defaultPurchaseOrderDueDayPeriod",
      p3.find((f) => f.name === "purchaseOrderDueDayPeriod")?.value || "",
    );
    localStorage.setItem(
      "defaultQuotationDueDayPeriod",
      p3.find((f) => f.name === "quotationDueDayPeriod")?.value || "",
    );
    localStorage.setItem(
      "defaultCurrency",
      p3.find((f) => f.name === "currency")?.value || "",
    );
  };

  const handleSubmit = async () => {
    // Step 1: Always save to localStorage first
    saveToLocalStorage();
    toast.success("Default values saved to Company Settings!");

    // Step 2: Try backend sync (optional — data already saved locally above)
    try {
      const token = localStorage.getItem("accessToken");
      const adminId = localStorage.getItem("adminId");
      const authHeader = { Authorization: `Bearer ${token}` };
      const jsonPayload = formatData(adminId);

      const response = await axios.post(
        `${path_url}/profile/welcome/${adminId}`,
        jsonPayload,
        { headers: { ...authHeader, "Content-Type": "application/json" } },
      );

      console.log("Backend response:", response?.data);
      const orgId = response?.data?.orgId || response?.data?.body?.orgId;
      const profileId =
        response?.data?.profileId || response?.data?.body?.profileId;

      if (response?.status === 200) {
        if (companyLogo && orgId) {
          const logoForm = new FormData();
          logoForm.append("companylogo", companyLogo);
          await axios
            .post(
              `${path_url}/profile/welcome/companylogo/${orgId}`,
              logoForm,
              {
                headers: {
                  ...authHeader,
                  "Content-Type": "multipart/form-data",
                },
              },
            )
            .catch((err) => console.warn("Company logo upload failed:", err));
        }
        if (profilePhoto && profileId) {
          const photoForm = new FormData();
          photoForm.append("profilePhoto", profilePhoto);
          await axios
            .post(
              `${path_url}/profile/welcome/profile/${profileId}`,
              photoForm,
              {
                headers: {
                  ...authHeader,
                  "Content-Type": "multipart/form-data",
                },
              },
            )
            .catch((err) => console.warn("Profile photo upload failed:", err));
        }
        toast.success("Data synced with server!");
      }
    } catch (error) {
      // Backend failed but data is already saved locally — don't show error
      console.warn(
        "Backend sync failed (data saved locally):",
        error?.response?.data || error.message,
      );
    }

    // Step 3: Always close modal after saving locally
    handleModal();
  };

  const getContentForPage = (page) => {
    return pageContents[page - 1];
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPageTransition("rotate-prev");
      setTimeout(() => {
        setCurrentPage(currentPage - 1);
        setCurrentPageTransition("");
      }, 500);
    }
  };

  const goToNextPage = () => {
    if (currentPage < nPages) {
      setCurrentPageTransition("rotate-next");
      setTimeout(() => {
        setCurrentPage(currentPage + 1);
        setCurrentPageTransition("");
      }, 500);
    }
  };

  //finding the last index of pageContents -> inputFields  array
  const inputFields = getContentForPage(currentPage).inputFields;
  const last_index = inputFields.length - 1;

  return (
    <div>
      <Modal
        disableAutoFocus={true}
        open={isModalOpen}
        onClose={handleModal}
        style={{
          overflowY: "auto",
          maxHeight: "100%",
          margin: "auto",
        }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body">
              {/* title and page position */}
              <div className="title-row d-flex justify-content-between align-items-center">
                <h3>
                  {currentPage === 1
                    ? "Company Information"
                    : currentPage === 2
                      ? "Personal Profile"
                      : "Default values"}
                </h3>
                <div className="d-flex align-items-center">
                  <h3>
                    Step {currentPage} of {nPages}
                  </h3>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setIsModalOpen(false);
                    }}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>

              {/* modal view contents */}
              <div className={`container ${currentPageTransition}`}>
                <div className="row">
                  <div className="col-sm-6 p-0">
                    <button
                      className="carousel-control-prev"
                      onClick={goToPrevPage}
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Previous</span>
                    </button>
                    {/* image for left side of modal */}
                    <div className="img-container">
                      <img
                        src={getContentForPage(currentPage).image}
                        alt="Illustration"
                      />
                    </div>
                  </div>

                  {/* form for right side of modal */}
                  <div className="data-row1 col-sm-6">
                    {getContentForPage(currentPage).inputFields.map(
                      (field, index) => {
                        // ── Country dropdowns ──
                        const isCountryDropdown =
                          (currentPage === 1 && index === inputCountryIndex) ||
                          (currentPage === 2 && index === inputCountryIndex2);

                        // ── Currencies dropdown (page 1) ──
                        const isCurrencyDropdown =
                          currentPage === 1 && index === inputCurrencyIndex;

                        // ── Timezone dropdown (page 1) ──
                        const isTimezoneDropdown =
                          currentPage === 1 && index === inputTimezoneIndex;

                        // ── Company type dropdown (page 1) ──
                        const isCompanyTypeDropdown =
                          currentPage === 1 && index === inputCompanyTypeIndex;

                        // ── Currency dropdown on page 3 ──
                        const isPage3CurrencyDropdown =
                          currentPage === 3 && index === last_index - 1;

                        // ── File upload (last index) ──
                        const isFileInput = index === last_index;

                        // ── Textarea (page 2, notes field) ──
                        const isTextarea =
                          currentPage === 2 && index === last_index - 1;

                        if (isCountryDropdown) {
                          return (
                            <div className="country-dropdown" key={index}>
                              <select
                                className="form-control mb-2"
                                value={field.value}
                                onChange={(e) => {
                                  const selectedCountryIndex =
                                    e.target.selectedIndex - 1;
                                  handleChange(
                                    e,
                                    currentPage - 1,
                                    index,
                                    selectedCountryIndex,
                                  );
                                }}
                              >
                                <option value="">Select Country</option>
                                {countryData.countries.map((country, i) => (
                                  <option key={i} value={country.country_name}>
                                    {country.country_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          );
                        }

                        if (isCurrencyDropdown) {
                          return (
                            <div className="country-dropdown" key={index}>
                              <select
                                className="form-control mb-2"
                                value={field.value}
                                onChange={(e) =>
                                  handleChange(e, currentPage - 1, index)
                                }
                              >
                                <option value="">Select Currency</option>
                                {CURRENCIES_OPTIONS.map((code) => (
                                  <option key={code} value={code}>
                                    {code}
                                  </option>
                                ))}
                              </select>
                            </div>
                          );
                        }

                        if (isTimezoneDropdown) {
                          return (
                            <div className="country-dropdown" key={index}>
                              <select
                                className="form-control mb-2"
                                value={field.value}
                                onChange={(e) =>
                                  handleChange(e, currentPage - 1, index)
                                }
                              >
                                <option value="">Select Timezone</option>
                                {TIMEZONE_OPTIONS.map((tz) => (
                                  <option key={tz} value={tz}>
                                    {tz.replace(/_/g, " ")}
                                  </option>
                                ))}
                              </select>
                            </div>
                          );
                        }

                        if (isCompanyTypeDropdown) {
                          return (
                            <div className="country-dropdown" key={index}>
                              <select
                                className="form-control mb-2"
                                value={field.value}
                                onChange={(e) =>
                                  handleChange(e, currentPage - 1, index)
                                }
                              >
                                <option value="">Select Company Type</option>
                                {COMPANY_TYPE_OPTIONS.map((ct) => (
                                  <option key={ct} value={ct}>
                                    {ct.replace(/_/g, " ")}
                                  </option>
                                ))}
                              </select>
                            </div>
                          );
                        }

                        if (isPage3CurrencyDropdown) {
                          return (
                            <div className="country-dropdown" key={index}>
                              <select
                                className="form-control mb-2"
                                value={field.value}
                                onChange={(e) =>
                                  handleChange(e, currentPage - 1, index)
                                }
                              >
                                <option value="">Select Currency</option>
                                {CURRENCIES_OPTIONS.map((code) => (
                                  <option key={code} value={code}>
                                    {code}
                                  </option>
                                ))}
                              </select>
                            </div>
                          );
                        }

                        if (isFileInput) {
                          return (
                            <div className="image-holder" key={index}>
                              <label
                                htmlFor="myImage"
                                className="file-input-label"
                              >
                                {
                                  getContentForPage(currentPage)
                                    .inputFieldPlaceholders[index]
                                }
                              </label>
                              <Tooltip
                                title={
                                  getContentForPage(currentPage)
                                    .inputFieldPlaceholders[index]
                                }
                                classes={{ tooltip: "custom-tooltip" }}
                                placement="top"
                                arrow
                              >
                                <input
                                  type="file"
                                  name="myImage"
                                  accept="image/*"
                                  className="form-control mb-2 image-uploader"
                                  onChange={(e) =>
                                    handleChange(e, currentPage - 1, index)
                                  }
                                />
                              </Tooltip>
                            </div>
                          );
                        }

                        if (isTextarea) {
                          return (
                            <textarea
                              key={index}
                              className="form-control mb-2"
                              placeholder={
                                getContentForPage(currentPage)
                                  .inputFieldPlaceholders[index]
                              }
                              value={field.value}
                              onChange={(e) =>
                                handleChange(e, currentPage - 1, index)
                              }
                            />
                          );
                        }

                        // Default: normal text input
                        return (
                          <input
                            key={index}
                            type="text"
                            placeholder={
                              getContentForPage(currentPage)
                                .inputFieldPlaceholders[index]
                            }
                            className="form-control mb-2"
                            value={field.value}
                            onChange={(e) =>
                              handleChange(e, currentPage - 1, index)
                            }
                          />
                        );
                      },
                    )}

                    {/* left and right page navigation buttons for carousel */}
                    <button
                      className="carousel-control-prev mobile-control-left-carousel d-block d-sm-none"
                      onClick={goToPrevPage}
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      onClick={goToNextPage}
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>

                {/* pagination component which shows page numbers */}
                <div className="pagination-container">
                  {/* <PaginationComponent 
                    currentPage={currentPage} 
                    setCurrentPage={setCurrentPage} 
                    nPages={nPages} 
                  /> */}
                </div>
                {/* Cancel and Save buttons — only on Personal Profile page (page 2) */}
                {currentPage === 2 && (
                  <div className="d-flex justify-content-end gap-2 mt-2">
                    <button
                      type="button"
                      className="btn"
                      style={{ border: "1px solid #ccc" }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn"
                      style={{ border: "1px solid #ccc" }}
                      onClick={() => handleSubmit()}
                    >
                      Save
                    </button>
                  </div>
                )}
                {/* submit button — only on Default Values page (page 3) */}
                {currentPage === 3 && (
                  <button
                    type="button"
                    className="btn btn-primary float-end"
                    onClick={() => handleSubmit()}
                  >
                    Save changes
                  </button>
                )}
              </div>

              {/* page position indicators */}
              <div className="carousel-indicators-container">
                <ol className="carousel-indicators">
                  {Array.from({ length: nPages }, (_, i) => (
                    <li
                      key={i}
                      data-slide-to={i}
                      className={i === currentPage - 1 ? "active" : ""}
                    />
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default RegisterNewUserModal;
